import { gtagWrapper } from '../google-analytics/utils';
import type { Metric, TrackWebVitals, TrackWebVitalsParams } from './types';

const trackWebVitals = ({
  category,
  label,
  page,
}: TrackWebVitalsParams): TrackWebVitals => {
  return {
    handler: (metric: Metric) => {
      gtagWrapper('event', metric.name, {
        value: metric.delta,
        metric_id: metric.id,
        metric_value: metric.value,
        metric_delta: metric.delta,
        screen_name: page,
        event_category: category,
        event_label: label,
      });
    },
  };
};

export default trackWebVitals;
